var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{ref:"bsCheckbox",staticClass:"d-flex mh-0 w-100 pl-0 gmb-checkbox",attrs:{"size":"sm","switch":_vm.switcherStyle,"uncheckedValue":null,"value":_vm.value},on:{"input":(bsCheckboxGroupNewActivatedValues) =>
      _vm.onActivatedValueChanged(bsCheckboxGroupNewActivatedValues)},nativeOn:{"click":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }